export enum SefrKiloometrEnum {
  YES = 0,
  NO = 1,
}
